module.exports = __webpack_public_path__ + "static/media/8OLA28.d3fc33d1.jpg";